import infyImage from '../images/infy.png';
import cdjr_img from '../images/cdjr.png';
import blstk_logo from '../images/blstk.png';
import infy_cert_img from '../images/infy_cert.png';
import blstk_cert_img from '../images/blstk_cert.jpg';
import codingjr_cert_img from '../images/codingjr_cert.png';
import moronss_cert_img from '../images/moronss_cert.png';
import moronss_logo from '../images/Moronss_logo.png';
import gssoc_img from '../images/gssoc_logo.png';
import gssoc_banner_img from'../images/gssoc_banner.png';
import manipal_logo from '../images/manipal.png';
import allen from '../images/allen.png';
import tsxs from '../images/tsxs.png';
import acm_logo from '../images/acm.png';
import mbosc_logo from '../images/mbosc.png';
import neura_ai_logo from '../images/neura_ai.png';
import RL_Logo from '../images/RL.png';
import deepfake from '../images/deepfake.png';
import tech_img from '../images/tech_img.png';
import vqa_img from '../images/vqa.png';
import hero_img from '../images/HeroImage.jpg';
import express_logo from '../images/express.png';
import langchain_logo from '../images/langchain.png';
import fastapi_logo from '../images/fastapi.png';
import postman_logo from '../images/postman.png';
import figma from '../images/figma.png';
import git from '../images/git.png';
import canva from '../images/canva.png';
import vso_logo from '../images/vso_logo.png';
import kornia_logo from '../images/kornia_logo.png';
import team_everest_logo from '../images/team_everest_logo.png';


import quantum_iot_net from '../images/quantum_iot_net_1783173576574.png';
import graph_rep_learning from '../images/graph_rep_learning_1783173588629.png';
import hamp_net_training from '../images/hamp_net_training_1783173600155.png';
import federated_learning from '../images/federated_learning_1783173610628.png';
import secure_qr_mcp from '../images/secure_qr_mcp_1783173622312.png';
import ensemble_ai from '../images/ensemble_ai_1783173633012.png';
import quantum_blockchain from '../images/quantum_blockchain_1783173642940.png';
import anomaly_iot from '../images/anomaly_iot_1783173654616.png';
import phishzero_security from '../images/phishzero_security_1783173665473.png';


import amazon_ml_summer_school from '../images/amazon_ml_summer_school_real.png';
import ieee_conecct_award from '../images/ieee_conecct_award.png';
import bhtc_poster_award from '../images/bhtc_poster_award.png';
import image_intl from '../images/custom_logos/image_intl.png';
import image_amzn from '../images/custom_logos/image_amzn.png';
import image_nokia from '../images/custom_logos/image_nkia.png';

export const recentUpdates = [
  {
    id: 1,
    title: "Amazon ML Summer School 2026",
    description: "Selected for Amazon ML Summer School consecutively for the second year - 2026 Cohort.",
    date: "2026-07-04",
    type: "blog",
    isNew: true,
    image: amazon_ml_summer_school,
    tags: ["Amazon", "Machine Learning", "Summer School"],
    link: "#"
  },
  {
    id: 2,
    title: "7 Papers Accepted at IEEE CONECCT",
    description: "Successfully got 7 research papers accepted at the prestigious IEEE CONECCT conference.",
    date: "2026-07-03",
    type: "blog",
    isNew: true,
    image: ieee_conecct_award,
    tags: ["Research", "IEEE CONECCT", "Publications"],
    link: "/blog/5"
  },
  {
    id: 3,
    title: "Best Paper Award at IEEE CONECCT",
    description: "Honored to receive the Best Paper Award at IEEE CONECCT for outstanding research contributions.",
    date: "2026-07-02",
    type: "blog",
    isNew: true,
    image: ieee_conecct_award,
    tags: ["Award", "IEEE", "Research"],
    link: "#"
  },
  {
    id: 4,
    title: "Paper Accepted as BHTC Poster",
    description: "Our research paper has been accepted for a poster presentation at BHTC.",
    date: "2026-06-25",
    type: "blog",
    isNew: true,
    image: bhtc_poster_award,
    tags: ["BHTC", "Poster", "Research"],
    link: "#"
  },
  {
    id: 5,
    title: "Best Poster Award at BHTC",
    description: "Won the Best Poster Award at BHTC for our accepted research poster.",
    date: "2026-06-26",
    type: "blog",
    isNew: true,
    image: bhtc_poster_award,
    tags: ["Award", "BHTC", "Research"],
    link: "#"
  }
];

export const volunteering = [
  {
    id: 1,
    img: vso_logo,
    role: "Volunteer",
    company: "VSO Mahe, Manipal",
    date: "2023 – Present",
    desc: "Actively volunteered with VSO (Voluntary Service Overseas) Mahe chapter at Manipal, contributing to community development and social impact initiatives. Engaged in awareness campaigns, skill-building workshops, and grassroots outreach programs aimed at empowering underserved communities. Collaborated with a multidisciplinary team of volunteers on health, education, and livelihood projects.",
    skills: ["Community Development", "Outreach", "Leadership", "Teamwork", "Social Impact"],
  },
  {
    id: 2,
    img: team_everest_logo,
    role: "Volunteer",
    company: "Team Everest",
    date: "2022 – 2023",
    desc: "Volunteered with Team Everest, a youth-led NGO focused on social transformation through education and empowerment. Participated in teaching programs, environmental drives, and community engagement events. Worked hands-on with underprivileged youth to improve access to learning resources and build foundational digital literacy skills.",
    skills: ["Education Outreach", "Youth Empowerment", "Event Coordination", "Digital Literacy"],
  },
  {
    id: 3,
    img: gssoc_img,
    role: "Open Source Contributor",
    company: "GSSoC & GitHub Open Source",
    date: "2023 – Present",
    desc: "Active open source contributor across multiple repositories on GitHub. Participated in GirlScript Summer of Code (GSSoC) contributing to community-driven projects. Contributions span bug fixes, feature additions, documentation improvements, and code reviews across AI/ML, web development, and developer tooling projects.",
    skills: ["Git", "GitHub", "Pull Requests", "Code Review", "Documentation", "Open Source"],
  },
  {
    id: 4,
    img: kornia_logo,
    role: "Open Source Contributor — 2 Merged PRs",
    company: "Kornia · 10k+ ⭐ Computer Vision Library",
    date: "2024",
    desc: "Contributed to Kornia, the leading open source differentiable computer vision library built on PyTorch with 10,000+ GitHub stars. Had 2 pull requests merged into the main codebase — implementing enhancements to core vision transform modules and improving numerical stability of geometric operations. Working alongside a global community of CV researchers and engineers.",
    skills: ["PyTorch", "Computer Vision", "Differentiable CV", "Open Source", "Python", "Linear Algebra"],
    report_link: "https://github.com/kornia/kornia",
    report_button_text: "View GitHub",
  },
];


export const Bio = {
  name: "Panchadip Bhattacharya",
  roles: [
    "AI ML Engineer",
    "Software Developer",
    "Data Science Professional",
    "Full Stack Developer",
    "Programmer",
  ],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/Panchadip-128",
  resume:
    "https://docs.google.com/document/d/1OMdw_DW7WV_DfLsPM7nV-Zmaf_m1gHrUA61MEYYtX-A/edit?usp=sharing",
  linkedin: "https://www.linkedin.com/in/panchadip-bhattacharya-192388228/",
  twitter: "#",
  insta: "https://www.instagram.com/its_panchadip/",
  facebook: "#",
};

export const skills = [
  {
    title: "Artificial Intelligence & GenAI",
    skills: [
      { name: "Llama Models", image: "https://cdn.simpleicons.org/meta/0668E1" },
      { name: "Google Gemini", image: "https://cdn.simpleicons.org/googlegemini/4285F4" },
      { name: "GPT / OpenAI", image: "https://cdn.simpleicons.org/openai/white" },
      { name: "HuggingFace", image: "https://cdn.simpleicons.org/huggingface/FFD21E" },
      { name: "LangChain", image: langchain_logo },
      { name: "RAG Pipelines", image: "https://img.icons8.com/color/48/000000/data-configuration.png" },
      { name: "AI Agents", image: "https://img.icons8.com/color/48/000000/bot.png" },
      { name: "Prompt Engineering", image: "https://img.icons8.com/color/48/000000/console.png" },
      { name: "Vector Databases", image: "https://img.icons8.com/color/48/000000/database.png" },
      { name: "Model Fine-Tuning", image: "https://img.icons8.com/color/48/000000/settings.png" },
      { name: "MCP Protocol", image: "https://img.icons8.com/color/48/000000/network-cable.png" }
    ],
  },
  {
    title: "Data Science & Machine Learning",
    skills: [
      { name: "Python", image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg" },
      { name: "TensorFlow", image: "https://cdn.simpleicons.org/tensorflow/FF6F00" },
      { name: "PyTorch", image: "https://cdn.simpleicons.org/pytorch/EE4C2C" },
      { name: "Scikit-Learn", image: "https://cdn.simpleicons.org/scikitlearn/F7931E" },
      { name: "Pandas", image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/pandas/pandas-original.svg" },
      { name: "NumPy", image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/numpy/numpy-original.svg" },
      { name: "Matplotlib", image: "https://img.icons8.com/color/48/000000/line-chart.png" },
      { name: "Seaborn", image: "https://seaborn.pydata.org/_images/logo-mark-lightbg.svg" },
      { name: "XGBoost", image: "https://avatars.githubusercontent.com/u/17173059?s=200&v=4" }
    ],
  },
  {
    title: "Backend & API",
    skills: [
      { name: "Node Js", image: "https://nodejs.org/static/images/logo.svg" },
      { name: "Express Js", image: express_logo },
      { name: "FastAPI", image: fastapi_logo },
      { name: "Flask", image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/flask/flask-original.svg" },
      { name: "Django", image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/django/django-plain.svg" },
      { name: "Graph Ql", image: "https://www.vectorlogo.zone/logos/graphql/graphql-icon.svg" },
      { name: "REST APIs", image: "https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg" }
    ],
  },
  {
    title: "Frontend",
    skills: [
      { name: "React Js", image: "https://cdn.simpleicons.org/react/61DAFB" },
      { name: "Next Js", image: "https://cdn.simpleicons.org/nextdotjs/white" },
      { name: "TypeScript", image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg" },
      { name: "JavaScript", image: "https://cdn.simpleicons.org/javascript/F7DF1E" },
      { name: "HTML", image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png" },
      { name: "CSS", image: "https://cdn.simpleicons.org/css3/1572B6" },
      { name: "Bootstrap", image: "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png" },
      { name: "Material UI", image: "https://mui.com/static/logo.png" }
    ],
  },
  {
    title: "Databases & Cloud",
    skills: [
      { name: "MySQL", image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg" },
      { name: "PostgreSQL", image: "https://www.postgresql.org/media/img/about/press/elephant.png" },
      { name: "MongoDB", image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg" },
      { name: "Redis", image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/redis/redis-original.svg" },
      { name: "SQLite3", image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/sqlite/sqlite-original.svg" },
      { name: "Firebase", image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg" },
      { name: "MS Azure", image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/azure/azure-original.svg" }
    ],
  },
  {
    title: "DevOps & Tools",
    skills: [
      { name: "Git", image: git },
      { name: "GitHub", image: "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png" },
      { name: "Docker", image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg" },
      { name: "Postman API", image: postman_logo },
      { name: "VS Code", image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/vscode/vscode-original.svg" },
      { name: "Linux", image: "https://cdn.simpleicons.org/linux/white" }
    ],
  },
  {
    title: "Cybersecurity",
    skills: [
      { name: "Kali Linux", image: "https://cdn.simpleicons.org/kalilinux/557C94" },
      { name: "Metasploit", image: "https://img.icons8.com/color/48/000000/bug.png" },
      { name: "Ethical Hacking", image: "https://img.icons8.com/color/48/000000/hacker.png" },
      { name: "CTF", image: "https://img.icons8.com/color/48/000000/flag.png" }
    ],
  }
];


export const experiences = [
  {
    id: 14,
    img: image_amzn,
    role: "Amazon ML School Mentee - 2026 Cohort",
    company: "Amazon",
    date: "July 2026",
    desc: "Selected for the 2026 cohort, mentored by Amazon scientists and team on industry ML projects and advanced AI applications.",
    skills: [
      "Machine Learning",
      "Generative AI",
      "Data Science",
      "Python"
    ],
  },
  {
    id: 13,
    img: image_nokia,
    role: "Project Intern-Agentic AI & Security",
    company: "Nokia",
    date: "2026",
    desc: "Working on cutting-edge Agentic AI solutions and security systems.",
    skills: [
      "Agentic AI",
      "Security",
      "Machine Learning",
      "Python"
    ],
  },
  {
    id: 12,
    img: image_amzn,
    role: "Amazon ML School Mentee",
    company: "Amazon",
    date: "July 2025",
    desc: "Selected among top 3000 candidates out of 60,000+ candidates, mentored by Amazon scientists and team on different industry ML projects and applications.",
    skills: [
      "Machine Learning",
      "Deep Learning",
      "Data Science",
      "Python"
    ],
  },
  {
    id: 11,
    img: image_intl,
    role: "Project Trainee Intern",
    company: "Intel Corporation",
    date: "May 2025 - August 2025",
    desc: "Developing a tag generation pipeline using the Qwen2-1.5B Instruct LLM to automatically classify research papers across 50+ categories, increasing enrichment speed by 70% and enabling large-scale topic discovery deployed using Kubernetes. Developed a modular, end-to-end sentiment analysis system with 6+ microservices (PII anonymization, profanity masking, sentiment classification, topic modeling), deployed via Docker, FastAPI, and Streamlit, improving review processing speed by 65% and enabling real-time feedback analysis across 1000+ entries.",
    skills: [
      "Qwen2-1.5B",
      "LLMs",
      "Kubernetes",
      "Microservices",
      "Docker",
      "FastAPI",
      "Streamlit",
      "Python"
    ],
  },
  {
    id: 0,
    img: infyImage,
    role: "SDE Full Stack Python Developer",
    company: "Infosys",
    date: "November 2024 - December 2024",
    desc: "During my internship at Infosys Springboard, I honed a diverse set of technical and leadership skills while working on the development of a Full-Stack Food Delivery Platform. As the Team Leader, I successfully managed the project lifecycle using the Agile methodology, ensuring seamless collaboration, task delegation, and timely delivery. On the frontend, I utilized HTML, CSS, and JavaScript, along with data visualization libraries like Chart.js and Plotly, to create interactive and user-friendly dashboards tailored for Admins, Users, and Delivery Agents. For the backend, I leveraged Python with frameworks such as Flask and Django to build robust APIs, ensuring secure and efficient communication between the frontend and backend. I also conducted extensive API testing using Postman and implemented unit testing to guarantee reliability and performance. My expertise in database design was demonstrated through the creation of optimized ER diagrams and the use of MySQL and SQLite for structured and scalable data storage. Additionally, I integrated machine learning models using Scikit-learn, Pandas, and NumPy to enhance platform functionality with features like anomaly detection, sentiment analysis, and customer prediction. For data visualization and analytics, I employed tools like Matplotlib and Seaborn to generate insightful reports on sales trends, customer demographics, and feedback analysis. Beyond technical skills, this experience strengthened my problem-solving abilities, team leadership, and project management expertise, while deepening my understanding of data-driven decision-making and scalable application design. This comprehensive exposure to full-stack development, coupled with hands-on experience in machine learning integration, has equipped me with the skills to tackle complex challenges and deliver innovative solutions in future project.",

    skills: [
      "Flask",
      "JavaScript",
      "MySQL",
      "SQLite3",
      "Postman API",
      "Matplotlib",
      "Seaborn",
      "Scikit-Learn",
      "Pandas",
      "Leadership",
    ],
    doc: infy_cert_img,
    report_link: "https://github.com/Panchadip-128/Project-Reports/blob/main/Project-Report-Hifi_Delivery_Eats.pdf",
   
  },
  
  
  {
    id: 2,
    img: cdjr_img,
    role: "AI - Data Science Intern ",
    company: "Coding Jr",
    date: "June 2024 - August 2025",
    desc: "During my internship at Coding Jr, I had the incredible opportunity to work on cutting-edge projects in Generative AI and developer productivity tools. My primary contribution was the development of a VS Code Copilot extension powered by advanced Large Language Models (LLMs) such as GPT-3.5-turbo, Llama 3.1, and Gemini 1.5. This extension provides real-time code suggestions, intelligent debugging, and seamless model switching, significantly enhancing developer efficiency. I focused on fine-tuning LLMs for accuracy, optimizing response times, and designing an intuitive user interface using HTML, CSS, and JavaScript. Leveraging a robust tech stack that included Node.js, TypeScript, and the VS Code API, I delivered a scalable and user-friendly solution. This experience deepened my expertise in Generative AI, software development, and front-end design while reinforcing the importance of user-centric innovation. I am excited to continue exploring the transformative potential of AI-driven tools in the tech ecosystem.",
    doc: codingjr_cert_img,
    skills: [
      "TypeScript",
      "LLM Finetuning",
      "NLP",
      "React Js",
      "Node Js",
      "Google Gemini 1.5 ",
      "GPT-3.5 turno",
      "Llama LLM Engine",
    ],
    report_link: "https://github.com/Panchadip-128/Project-Reports/blob/main/Project-Report-%20LLM%20Copilot%20Extension.pdf",
    
  },
  {
    id: 3,
    img: blstk_logo ,
    role: "SDE Intern",
    company: "Bluestocks",
    date: "November 2024 - December 2024 ",
    desc: "During my internship at Bluestock Fintech, I developed a comprehensive IPO Management System, gaining hands-on experience in full-stack development. The project involved creating a web application and REST API using Django, PostgreSQL, HTML, CSS, JavaScript, and Bootstrap. Key features included IPO listings with detailed information, user subscription management, transaction history tracking, and downloadable IPO-related PDFs. I also implemented user authentication and developed a REST API for external integration. The system followed the Model-View-Template (MVT) architecture and was rigorously tested using unit, integration, and manual testing methods. This project enhanced my skills in backend development, API creation, and responsive UI design while improving my problem-solving abilities. The final product was a fully functional, user-friendly application, successfully deployed and tested, with potential for future enhancements like payment gateway integration and advanced reporting.",
    doc: blstk_cert_img,
    skills: [
      "Bootstrap CSS",
      "Django-REST Framework",
      "JavaScript",
      "REST APIs",
      "PostgreSQL",
      "Git",
      "HTML",
    ],
    report_link:"https://github.com/Panchadip-128/Project-Reports/blob/main/Bluestocks%20Report.pdf",
    
  },
  
  {
    id: 5,
    img: moronss_logo,
    role: "AI ML Developer",
    company: "The Moronss- AI Recruitment workplace",
    date: "July 2024 - September 2024",
    desc: "The development of the AI Resume Screening/Parsing Tool followed a structured, iterative ML approach aligned with business goals. Key steps included exploratory data analysis (EDA), feature engineering (e.g., one-hot encoding, normalization), and model design using algorithms like Random Forest, Gradient Boosting, and Neural Networks. Frameworks such as TensorFlow, PyTorch, and Scikit-learn were utilized, with debugging and regularization techniques (e.g., L1/L2 penalties, dropout) ensuring robustness.Prototyping on platforms like AWS SageMaker and Google Colab enabled rapid experimentation, while Git managed code changes. Collaboration with data engineers, product managers, and developers ensured clean pipelines, aligned metrics, and seamless production integration. Usability testing and stakeholder feedback drove iterative improvements, addressing misclassifications, bias (via fairness-aware algorithms), and latency (via quantization and pruning). Hyperparameter tuning and architectural optimizations improved accuracy by 20% and reduced latency by 30%, enhancing user satisfaction and deployment speed. This comprehensive approach ensured a high-performing, fair, and user-friendly tool.",

    skills: [
      "CTF",
      "Hack The Box",
      "HackerOne",
      "PicoCTF",
      "Linux",
      "Kali",
      "Footprinting",
      "Metasploit",
    ],
    doc: moronss_cert_img,
    report_link: "https://github.com/Panchadip-128/Project-Reports/blob/main/Report%20on%20ML%20Model%20Development-The%20Moronss_AI%20Recruitment_Workplace.pdf"
    
  },
  {
    id: 4,
    img: gssoc_img,
    role: "Ranked 124 at GSSoC Extd 2024",
    company: "GirlsScript Summer of Code",
    date: "October 2024-November 2024",
    desc:"Participating in GSSoC 2024 Extended Edition was an incredible journey that deepened my engagement with open-source, allowed me to build meaningful solutions, and collaborate with a talented community of developers. I’m honored to have been ranked 124th among the top 150 participants out of thousands of contributors. During this experience, I made advanced open-source contributions, focusing on optimizing code quality and implementing scalable solutions. I also earned the Postman API Student Certification, enhancing my skills in API design and testing, and successfully completed Hacktoberfest 2024, driving key contributions across repositories while tackling complex issues that honed my problem-solving abilities. This journey enabled me to master new tools and frameworks, reinforcing my adaptability and technical expertise, while also enhancing my Git/GitHub workflows for streamlined project contributions and effective version control in team settings. Additionally, I built strong connections with experienced developers, fostering knowledge exchange within the open-source community.",
    // skills: [
    //   "Android",
    //   "Java",
    //   "Kotlin",
    //   "XML",
    //   "Node Js",
    //   "Cloud Firestore",
    //   "Firebase",
    //   "Figma",
    // ],
    doc: gssoc_banner_img,
  },
 
  
  
];

export const education = [
  {
    id: 0,
    img: manipal_logo,
    school: "Manipal Institute of Technology, Bengaluru",
    date: "July 2023 - August 2027",
    grade: "8.00 CGPA",
    desc: "I am currently pursuing a Bachelor's degree in Computer Science and Engineering with specialization in AI at Manipal Institute of Technology, Bengaluru, MAHE Manipal. I have completed 3 semesters and have a CGPA of 8.00. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Digital Systems, and Computer Networks, among others.",
    degree: "Bachelor of Technology - BTech, Computer Science and Engineering [AI]",
  },
  {
    id: 1,
    img: allen,
    school: "Allen Career Instt",
    date: 2023,
    grade: "90% (CBSE-XII) , 93 percentile(JEE M)",
    desc: "I completed my JEE preperation from Allen Career Institute and Schooling from SMI, Madhyamgram, Kolkata.",
    degree: "CBSE(XII), AISSE",
  },
  {
    id: 2,
    img: tsxs,
    school: "The St. Xavier's School, Malda",
    date: " ",
    grade: "92%",
    desc: "I completed my class 10th education, where I studied Science with Computer Science.",
    degree: "ICSE(X), Science with Computer",
  },
  
];

export const Positions = [
  {
    id: 0,
    img: acm_logo,
    role: "Vice Chair[SIG AI]",
    company: "Association of Computing & Machinery (ACM-MITB Student Chapter)",
    date: "November 2023 - Present",
    desc: "Since November 2023, I’ve led strategic growth and technical outreach for the ACM-MITB Student Chapter. I organized key events like HackMITB, AI/ML Bootcamps, and speaker sessions, while mentoring juniors in AI, Web Dev, CP, and Open Source. I conducted resume reviews, GitHub workshops, and built strong industry-academia ties through guest talks. By revamping branding and driving social media engagement, we boosted participation by 30%, helped students land internships and publish papers, and established a sustainable mentorship pipeline for vertical learning.",
    skills: [
      "Leadership",
      "Project Management",
      "AI",
      "Deep Learning",
      "ML",
      "Mentorship",
      "Web Development",
      "Research"
      
    ],
    // doc: infy_cert_img,
    // report_link: "https://github.com/Panchadip-128/Project-Reports/blob/main/Project-Report-Hifi_Delivery_Eats.pdf",
   
  },
  
  
  {
    id: 2,
    img: mbosc_logo,
    role: "Technical Chair ",
    company: "Manipal Bengaluru Open Source Community",
    date: "September 2023 - Present",
    desc: "As Technical Chair, I led the planning and execution of open source initiatives, hackathons, and project-based learning sessions. I mentored contributors in Git, GitHub, DevOps, and real-world project workflows, fostering a strong collaborative culture. I also streamlined contribution pipelines, increased engagement across domains, and helped scale community-driven development and innovation.",
    // doc: codingjr_cert_img,
    skills: [
      "TypeScript",
      "LLM Finetuning",
      "NLP",
      "React Js",
      "Node Js",
      "Google Gemini 1.5 ",
      "GPT-3.5 turno",
      "Llama LLM Engine",
    ],
    report_link: " ",
    
  },
  {
    id: 3,
    img: neura_ai_logo,
    role: "Technical Lead",
    company: "Neura AI",
    date: "November 2024 - Present",
    desc: "As Technical Lead at Neura AI, I spearheaded the development of AI-driven solutions, led a cross-functional team, and oversaw end-to-end project deployment. I contributed to model optimization, system architecture, and integrated scalable APIs, while mentoring interns and ensuring timely delivery of high-impact features.",
   
    skills: [
      "Bootstrap CSS",
      "Django-REST Framework",
      "JavaScript",
      "REST APIs",
      "PostgreSQL",
      "Git",
      "HTML",
    ],
    report_link:"https://github.com/Panchadip-128/Project-Reports/blob/main/Bluestocks%20Report.pdf",
    
  },
];

export const publications = [
  {
    title: "Multi-Objective Edge Resource Optimization with D3QN-PER in Quantum-Classical IoT Edge Networks",
    authors: "Panchadip Bhattacharjee; Somyajeet Arukh; Advithiya Duddu; Nishanth Shet; Induj Gupta; Gururaj H L",
    conference: "2026 18th International Conference on COMmunication Systems and NETworks (COMSNETS)",
    year: "2026",
    link: "https://ieeexplore.ieee.org/document/11418298",
    image: quantum_iot_net,
    description: "Proposes a novel deep reinforcement learning approach using D3QN with Prioritized Experience Replay to optimize resource allocation in hybrid quantum-classical IoT edge networks. Achieves significant latency reduction and optimal load balancing."
  },
  {
    title: "Accelerating Robust Graph Representation Learning: A High-Performance Dual-Stream Contrastive Framework",
    authors: "Panchadip Bhattacharjee; Somyajeet Arukh; Sai Vishal Setti; Nishanth Shet; Gururaj H L",
    conference: "2025 IEEE 32nd International Conference on High Performance Computing",
    year: "2025",
    link: "https://ieeexplore.ieee.org/document/11485147",
    image: graph_rep_learning,
    description: "Presents a dual-stream contrastive learning framework that accelerates graph representation learning. The model robustly handles noisy data and improves node classification accuracy by dynamically contrasting topological and feature spaces."
  },
  {
    title: "HAMP-Net: GPU-Accelerated Hierarchical Adaptive Mixed-Precision Training with Gradient Compression for Image Classification",
    authors: "Panchadip Bhattacharjee; Somyajeet Arukh; Sai Vishal Setti; Nishanth Shet; Gururaj H L",
    conference: "2025 IEEE 32nd International Conference on High Performance Computing",
    year: "2025",
    link: "https://ieeexplore.ieee.org/document/11459325",
    image: hamp_net_training,
    description: "Introduces HAMP-Net, a GPU-accelerated training framework that dynamically adjusts precision levels and compresses gradients during image classification tasks, resulting in massive computational speedups without sacrificing model accuracy."
  },
  {
    title: "Federated Learning for Edge Devices: A BHTC Approach",
    authors: "Panchadip Bhattacharjee, et al.",
    conference: "IEEE",
    year: "2025",
    link: "https://ieeexplore.ieee.org/document/11502232",
    image: federated_learning,
    description: "Develops a Block-wise Hierarchical Transfer Coding (BHTC) approach for federated learning across edge devices. This mechanism significantly reduces communication overhead and enhances privacy preservation during decentralized model training."
  },
  {
    title: "Enhanced QR-MCP Protocol for Secure Communication",
    authors: "Panchadip Bhattacharjee, et al.",
    conference: "IEEE",
    year: "2025",
    link: "https://ieeexplore.ieee.org/document/11497756",
    image: secure_qr_mcp,
    description: "Designs an enhanced Quantum-Resistant Multi-Channel Protocol (QR-MCP) tailored for secure, high-speed communication in post-quantum environments, offering robust cryptographic defenses against advanced adversarial attacks."
  },
  {
    title: "Advanced Deepfake detection using Deep Learning algorithms",
    authors: "Panchadip Bhattacharjee, et al.",
    conference: "IEEE",
    year: "2024",
    link: "https://ieeexplore.ieee.org/document/11306625",
    image: deepfake,
    description: "Compares various CNN architectures, including VGGFace16 and DenseNet-121, combined with PCA and SVMs to detect synthetic media. Achieves over 95% classification accuracy in distinguishing real from deepfake imagery."
  },
  {
    title: "Explainable Stacked Ensemble Framework",
    authors: "Panchadip Bhattacharjee, et al.",
    conference: "IEEE",
    year: "2025",
    link: "https://ieeexplore.ieee.org/document/11497790",
    image: ensemble_ai,
    description: "Proposes an explainable stacked ensemble AI framework that integrates multiple predictive models. Uses SHAP and LIME methodologies to provide transparent, interpretable decision-making processes for critical applications."
  },
  {
    title: "QUIBC: Quantum Inspired Blockchain",
    authors: "Panchadip Bhattacharjee, et al.",
    conference: "IEEE",
    year: "2024",
    link: "https://ieeexplore.ieee.org/document/11392962",
    image: quantum_blockchain,
    description: "Introduces a Quantum-Inspired Blockchain architecture that leverages quantum entanglement principles to secure blocks. This framework aims to mitigate the vulnerabilities of classical blockchains against quantum computing threats."
  },
  {
    title: "Anomaly Detection Framework for IoT Networks",
    authors: "Panchadip Bhattacharjee, et al.",
    conference: "IEEE",
    year: "2025",
    link: "https://ieeexplore.ieee.org/document/11481935",
    image: anomaly_iot,
    description: "Presents a highly scalable anomaly detection framework tailored for large-scale IoT networks. Utilizes advanced machine learning models to identify network intrusions and malicious behavior with minimal false positives."
  },
  {
    title: "PhishZero: A Robust Anti-Phishing Solution",
    authors: "Panchadip Bhattacharjee, et al.",
    conference: "IEEE",
    year: "2025",
    link: "https://ieeexplore.ieee.org/document/11582842",
    image: phishzero_security,
    description: "Develops PhishZero, an intelligent anti-phishing solution utilizing real-time URL analysis and deep learning classifiers to preemptively block malicious domains and protect users from sophisticated social engineering attacks."
  }
];

export const projects = [
  {
    id: 1,
    title: "devboard",
    date: "2024",
    description: "An engineering intelligence system that tracks team productivity and predicts burnout, built on a highly-concurrent event pipeline and advanced data algorithms.",
    image: RL_Logo,
    tags: ["TypeScript", "Data Analysis", "Pipeline"],
    category: "machine learning",
    github: "https://github.com/Panchadip-128/devboard",
    member: [{ name: "Panchadip", img: hero_img, linkedin: "https://www.linkedin.com/in/panchadip-bhattacharya-192388228/", github: "https://github.com/Panchadip-128" }]
  },
  {
    id: 2,
    title: "Syncpad-Distributed-State-Synchronization-Engine",
    date: "2024",
    description: "SyncPad - a real‑time collaborative editor built on CRDTs, Lamport clocks, and Redis Pub/Sub. Branch documents like Git, replay edits like a timeline, and co‑write live with AI - engineered for scale.",
    image: tech_img,
    tags: ["TypeScript", "CRDTs", "Redis"],
    category: "web app",
    github: "https://github.com/Panchadip-128/Syncpad-Distributed-State-Synchronization-Engine",
    member: [{ name: "Panchadip", img: hero_img, linkedin: "https://www.linkedin.com/in/panchadip-bhattacharya-192388228/", github: "https://github.com/Panchadip-128" }]
  },
  {
    id: 3,
    title: "RAG_Based_Research_Assistant_System",
    date: "2024",
    description: "A research paper discovery platform that enables users to search the latest academic publications and interact with Al-powered analysis while providing full source citations and performance metrics.",
    image: tech_img,
    tags: ["TypeScript", "RAG", "Research", "AI"],
    category: "web app",
    github: "https://github.com/Panchadip-128/RAG_Based_Research_Assistant_System",
    member: [{ name: "Panchadip", img: hero_img, linkedin: "https://www.linkedin.com/in/panchadip-bhattacharya-192388228/", github: "https://github.com/Panchadip-128" }]
  },
  {
    id: 4,
    title: "MCP-First-Multi-Agent-Copilot-Framework-with-Hybrid-RAG-Streaming",
    date: "2024",
    description: "This project delivers an industry‑grade copilot platform with MCP protocol for agent messaging, hybrid RAG (vector + BM25) retrieval, streaming chat via SSE, and multi‑agent workflows (planner → coder).",
    image: vqa_img,
    tags: ["Python", "MCP", "RAG", "LLM"],
    category: "machine learning",
    github: "https://github.com/Panchadip-128/MCP-First-Multi-Agent-Copilot-Framework-with-Hybrid-RAG-Streaming",
    member: [{ name: "Panchadip", img: hero_img, linkedin: "https://www.linkedin.com/in/panchadip-bhattacharya-192388228/", github: "https://github.com/Panchadip-128" }]
  },
  {
    id: 5,
    title: "Multi-LLM-Copilot-Extension-for-VSCode",
    date: "2024",
    description: "A Copilot LLM chat engine based on Llama 70B and 300 series model (Complete end to end with Free Groq API). Our updated version uses Gemma and Llama 8B models for powerful code analysis, processing, debugging and workflow generation.",
    image: deepfake,
    tags: ["TypeScript", "LLM", "VSCode", "Groq"],
    category: "machine learning",
    github: "https://github.com/Panchadip-128/Multi-LLM-Copilot-Extension-for-VSCode-for-Code-Debugging-Workflow-Generation-Pattern-Visualization",
    member: [{ name: "Panchadip", img: hero_img, linkedin: "https://www.linkedin.com/in/panchadip-bhattacharya-192388228/", github: "https://github.com/Panchadip-128" }]
  },
  {
    id: 6,
    title: "Scalable-Sentiment-Analysis-System",
    date: "2024",
    description: "An end-to-end sentiment analysis pipeline with DistilBERT, featuring PII anonymization, profanity filtering, privacy-preserving NLP, deployment through Streamlit, FastAPI, React, Docker, Intel OpenVINO.",
    image: RL_Logo,
    tags: ["Python", "NLP", "FastAPI", "Docker", "React"],
    category: "machine learning",
    github: "https://github.com/Panchadip-128/Scalable-Sentiment-Analysis-System-with-Privacy-Preserving-NLP-and-Multi-Stage-Deployment",
    member: [{ name: "Panchadip", img: hero_img, linkedin: "https://www.linkedin.com/in/panchadip-bhattacharya-192388228/", github: "https://github.com/Panchadip-128" }]
  },
  {
    id: 7,
    title: "Smart-Classroom-System (CSTPE)",
    date: "2026",
    description: "A 10-module patent-ready Continuous Spatial-Temporal Presence Engine attendance system combining YOLOv8 liveness detection, multi-modal biometric fusion, zero-knowledge proofs, and blockchain-anchored audit trails.",
    image: secure_qr_mcp,
    tags: ["FastAPI", "YOLOv8", "React", "SQLite", "Biometrics", "Blockchain", "ZKP"],
    category: "machine learning",
    github: "https://github.com/Panchadip-128/Smart-Classroom-System",
    member: [{ name: "Panchadip", img: hero_img, linkedin: "https://www.linkedin.com/in/panchadip-bhattacharya-192388228/", github: "https://github.com/Panchadip-128" }]
  },
  {
    id: 8,
    title: "D-HAQNAS: Differentiable Hardware-Aware Quantum Neural Architecture Search",
    date: "2026",
    description: "A gradient-based framework that jointly optimizes quantum circuit topology and variational parameters under explicit NISQ hardware constraints for medical imaging, offering 96.21% accuracy on PneumoniaMNIST.",
    image: quantum_blockchain,
    tags: ["Python", "PyTorch", "PennyLane", "Quantum ML", "NAS", "NISQ"],
    category: "machine learning",
    github: "https://github.com/Panchadip-128/Differentiable-Hardware-Aware-Quantum-Neural-Architecture-Search",
    member: [{ name: "Panchadip", img: hero_img, linkedin: "https://www.linkedin.com/in/panchadip-bhattacharya-192388228/", github: "https://github.com/Panchadip-128" }]
  },
  {
    id: 9,
    title: "MST-Conformer: Multi-Scale Temporal Conformer for HAR",
    date: "2025",
    description: "A multi-scale temporal conformer deep learning model for wearable sensor-based Human Activity Recognition (HAR), achieving SOTA accuracies of 97.6% on UCI-HAR and 98.8% on UniMiB-SHAR.",
    image: federated_learning,
    tags: ["Python", "PyTorch", "Wearables", "HAR", "Conformer", "Transformer"],
    category: "machine learning",
    github: "https://github.com/Panchadip-128/MST-Conformer-MultiScale_Temporal_Conformer-for-HAR",
    member: [{ name: "Panchadip", img: hero_img, linkedin: "https://www.linkedin.com/in/panchadip-bhattacharya-192388228/", github: "https://github.com/Panchadip-128" }]
  },
  {
    id: 10,
    title: "Visual-Question-and-Answering-Model-using-BLIP-CLIP",
    date: "2024",
    description: "A Visual Question Answering (VQA) model built using the BLIP and CLIP framework. Extracts visual and textual embeddings to answer questions related to provided images, deployed via Gradio.",
    image: vqa_img,
    tags: ["Python", "VQA", "BLIP", "CLIP", "Gradio"],
    category: "machine learning",
    github: "https://github.com/Panchadip-128/Visual-Question-and-Answering-Model-using-BLIP-CLIP",
    member: [{ name: "Panchadip", img: hero_img, linkedin: "https://www.linkedin.com/in/panchadip-bhattacharya-192388228/", github: "https://github.com/Panchadip-128" }]
  },
  {
    id: 11,
    title: "Optimizing-Edge-Resource-Management-using-Deep-Reinforcement-Learning",
    date: "2024",
    description: "Quantum Key Distribution (QKD) resource management optimization using a Double Deep Q-Network (DDQN) for edge resource allocation, minimizing latency and maximizing secure key rates.",
    image: RL_Logo,
    tags: ["Python", "DDQN", "Reinforcement Learning", "QKD", "Edge Computing"],
    category: "machine learning",
    github: "https://github.com/Panchadip-128/-Optimizing-Edge-Resource-Management-using-Deep-Reinforcement-Learning-A-Comparative-Study-of-DQN-",
    member: [{ name: "Panchadip", img: hero_img, linkedin: "https://www.linkedin.com/in/panchadip-bhattacharya-192388228/", github: "https://github.com/Panchadip-128" }]
  },
  {
    id: 12,
    title: "Waste-Classification-using-DL-techniques",
    date: "2023",
    description: "Used various Deep Learning models (ANN, Basic CNN, VGG16, ResNet, MobileNetV2) to facilitate the process of waste classification and compared rigorous metrics for efficient results.",
    image: tech_img,
    tags: ["Python", "TensorFlow", "OpenCV", "CNN", "MobileNetV2"],
    category: "machine learning",
    github: "https://github.com/Panchadip-128/Waste-Classification-using-DL-techniques",
    member: [{ name: "Panchadip", img: hero_img, linkedin: "https://www.linkedin.com/in/panchadip-bhattacharya-192388228/", github: "https://github.com/Panchadip-128" }]
  },
  {
    id: 13,
    title: "Quantum-Circuit-Probability-Prediction",
    date: "2024",
    description: "The Quantum Circuit Probability Predictor is a machine learning-based application designed to predict the probability of measuring a specific quantum state using Neural Networks and Transformers.",
    image: deepfake,
    tags: ["Python", "Qiskit", "Transformers", "Quantum ML", "PyTorch"],
    category: "machine learning",
    github: "https://github.com/Panchadip-128/Quantum-Circuit-Probability-Prediction-using-Neural-Networks-and-Transformers",
    member: [{ name: "Panchadip", img: hero_img, linkedin: "https://www.linkedin.com/in/panchadip-bhattacharya-192388228/", github: "https://github.com/Panchadip-128" }]
  },
  {
    id: 14,
    title: "Image_Captioning_Application",
    date: "2024",
    description: "This project showcases the use of the BLIP model from Salesforce for image captioning, integrated into a Streamlit web application. Analyzes text input sentiment and provides captions for uploaded images.",
    image: vqa_img,
    tags: ["Python", "Flask", "Streamlit", "Hugging Face", "BLIP"],
    category: "machine learning",
    github: "https://github.com/Panchadip-128/Image_Captioning_Application",
    member: [{ name: "Panchadip", img: hero_img, linkedin: "https://www.linkedin.com/in/panchadip-bhattacharya-192388228/", github: "https://github.com/Panchadip-128" }]
  }
];

export const certifications = [
  {
    title: "AI-900: Microsoft Azure AI Fundamentals",
    issuer: "Microsoft",
    date: "Aug 2024",
    link: "https://learn.microsoft.com/en-us/users/panchadipbhattacharjee-5589/credentials/61b3492e88649291?ref=https%3A%2F%2Fwww.linkedin.com%2F",
    description: "Covers all concepts of AI and ML on Azure platform including use cases, services, and responsible AI."
  },
  {
    title: "Deep Learning Specialization-Neural Networks & DL",
    issuer: "DeepLearning.AI",
    date: "Dec 2024",
    link: "https://www.coursera.org/account/accomplishments/verify/6TH76LKY7ZTS",
     description: "Completed the Deep Learning Specialization by DeepLearning.AI, covering neural networks, backpropagation, TensorFlow, Keras, convolutional networks, sequence models, and optimization techniques with hands-on experience in building and deploying models."
  },
  {
    title: "Improving Deep Neural Networks: Hyperparameter Tuning, Regularization and Optimization",
    issuer: "DeepLearning.AI",
    date: "April 2025",
    link: "https://www.coursera.org/account/accomplishments/verify/JUVJ1ALD6JUD",
    description: "Completed the Improving Deep Neural Networks course by DeepLearning.AI, covering hyperparameter tuning, regularization"
  },

  {
    title: "Generative AI with LLMs",
    issuer: "DeepLearning.AI",
    date: "October 2024",
    link: "https://www.coursera.org/account/accomplishments/verify/J94VZAY77EFX",
    description: "Gained practical knowledge of generative AI, exploring its applications in creating business value. Learned from AWS AI experts about deploying AI in real-world use cases and leveraging cutting-edge generative AI technologies."
  },

  {
    title: "Generative AI and Prompt Engineering techniques",
    issuer: "IBM",
    date: "Jun 2024",
    link: "https://www.coursera.org/account/accomplishments/verify/C7XTPDSF3FFL",
    description: "Learned the fundamentals of prompt engineering in generative AI, including creating effective prompts, applying best practices, and using tools to refine prompts for better performance. Gained skills to craft precise inputs for achieving desired outputs in various AI applications."
  },

  {
    title: "Gen AI: Introduction and Applications",
    issuer: "IBM",
    date: "Jun 2024",
    link: "https://www.coursera.org/account/accomplishments/verify/V4W628F4C8FW",
    description: "In this course, learners explored generative AI and how it differs from discriminative AI. The course covered the capabilities of generative AI in creating content like text, images, code, and music. It also discussed real-world applications of generative AI across industries such as healthcare, entertainment, and software development."
  },

  {
    title: "Data Analytics: Ask Questions to make data driven decisions",
    issuer: "Google in Coursera",
    date: "Nov 2023",
    link: "https://www.coursera.org/account/accomplishments/verify/AJ92TYAMX74T",
    description: "This course covers the fundamentals of data analytics, including data types, data collection methods, and data analysis techniques. It emphasizes the importance of asking the right questions to make informed decisions based on data insights. "
  },



  
];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
